import { useLastPathSegment } from 'shared/hooks'
import { type BusinessProfileRoutes } from 'pages/settings/pages/compliance/pages/businessProfile/route/type'

export const usePathSegment = () => {
  return useLastPathSegment() as BusinessProfileRoutes
}
